<template>
  <div>
    <!-- 地图起始页。没有任何显示内容，仅仅是清除图层、重回地图（含乡镇种植面积柱形图） -->
  </div>
</template>
<script>
import map from './IndexMap.js'
export default {
  data() {
    return {}
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
    map.start(this)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
    map.destroy()
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen28896/map-zone/mask/start.vue